import { useState } from "react";
import { toast } from "sonner";
import { Undo2, Loader2 } from "lucide-react";
import { api, errorMessage } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

export const RestoreOriginalButton = ({ submissionId, title, onDone, testId = "restore-original", size = "sm" }) => {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const restore = async () => {
    setBusy(true);
    try { await api.post(`/admin/cleaner/submissions/${submissionId}/restore`); toast.success("Original audio is back on the episode"); setOpen(false); onDone?.(); }
    catch (e) { toast.error(errorMessage(e)); } finally { setBusy(false); }
  };
  return (
    <>
      <Button type="button" onClick={() => setOpen(true)} size={size} variant="outline" className="rounded-full border-amber-400/40 bg-amber-400/10 text-amber-200 hover:bg-amber-400/20" title="Put the original audio back" data-testid={testId}><Undo2 size={14} className="mr-1.5" /> Restore original</Button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent className="card-surface border-white/10" data-testid={`${testId}-dialog`}>
          <AlertDialogHeader>
            <AlertDialogTitle>Restore the original audio?</AlertDialogTitle>
            <AlertDialogDescription>{title ? <>“{title}” will</> : "This episode will"} go back to the file the host uploaded. The cleaned version stays in the Cleaner's history, so you can apply it again later.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel className="rounded-full" data-testid={`${testId}-cancel`}>Keep cleaned audio</AlertDialogCancel>
            <AlertDialogAction onClick={(e) => { e.preventDefault(); restore(); }} disabled={busy} className="rounded-full bg-amber-400 text-[#1a1200] font-bold hover:bg-amber-300" data-testid={`${testId}-confirm`}>{busy ? <Loader2 size={14} className="mr-1.5 animate-spin" /> : <Undo2 size={14} className="mr-1.5" />} Restore original</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
